import { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ProfileChevron from '@/assets/svgs/profile-chevron.svg?react'
import IconBuilding from '@/assets/svgs/icon-building.svg?react'
import Popover from '@/components/Popover'

export const Profile = ({ label, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef()

  useEffect(() => {
    const handleClickOutside = e => {
      if (isOpen && ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [isOpen])

  return (
    <div className="relative" ref={ref}>
      <div
        className="flex items-center min-w-45 max-phone:min-w-0 cursor-pointer"
        onClick={() => setIsOpen(v => !v)}
      >
        <div>
          <div className="w-9 h-9 rounded-[5px] bg-grey-98 flex items-center justify-center">
            <IconBuilding className="w-[25px] h-[25px]" />
          </div>
        </div>
        <div className="ml-2.5">
          <div className="flex items-center">
            <div className="font-avenir-heavy type-body-1">{label}</div>
            <div className="flex ml-3">
              <ProfileChevron />
            </div>
            <Popover visible={isOpen} placement="bottom-end">
              <Popover.Content>
                <div className="absolute right-0 w-40 mt-5 pt-3.75 pr-3.75 pb-3.75 pl-5 border border-divider rounded-[6px] bg-white">
                  <div className="p-1.25 cursor-pointer font-avenir type-body-2" onClick={onLogout}>
                    Logout
                  </div>
                </div>
              </Popover.Content>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  )
}

Profile.propTypes = {
  label: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
}
